import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./DifferentCommitties/style.css";
import "./BoardSwiper.css";

// Import required modules
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import { Box, Card, CardMedia, Fade, Modal, styled } from "@mui/material";

import eboard from "../../../pictures/Board-Placeholder/eboard.jpg";
import oboard1 from "../../../pictures/Board-Placeholder/oboard1.jpg";
import oboard2 from "../../../pictures/Board-Placeholder/oboard2.jpg";
import oboard3 from "../../../pictures/Board-Placeholder/oboard3.jpg";
import oboard4 from "../../../pictures/Board-Placeholder/oboard4.jpg";
import oboard5 from "../../../pictures/Board-Placeholder/oboard5.jpg";

const CustomPositionCard = styled(Card)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: "20px",
}));

const boardImages = [eboard, oboard1, oboard2, oboard3, oboard4, oboard5];

export default function BoardSwiper() {
  const [zoomedImage, setZoomedImage] = useState(null);

  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 10,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        keyboard={{
          enabled: true
        }}
        navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="board-swiper"
      >
        {boardImages.map((image, index) => (
          <SwiperSlide key={index}>
            <CustomPositionCard elevation={5}>
              <CardMedia
                component="img"
                image={image}
                alt="Board Member"
                onClick={() => setZoomedImage(image)}
                style={{ width: "100%", height: "100%", objectFit: "cover", cursor: "zoom-in" }}
              />
            </CustomPositionCard>
          </SwiperSlide>
        ))}
      </Swiper>

      <Modal
        open={!!zoomedImage}
        onClose={() => setZoomedImage(null)}
        closeAfterTransition
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Fade in={!!zoomedImage}>
          <Box
            component="img"
            src={zoomedImage}
            alt="Board Member enlarged"
            onClick={() => setZoomedImage(null)}
            sx={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "12px",
              cursor: "zoom-out",
              outline: "none",
            }}
          />
        </Fade>
      </Modal>
    </>
  );
}
